(function (angular) {
	angular.module('bizPartEngage').directive('bizLayoutComponent', bizLayoutComponent);
	angular.module('bizPartEngage').service('bizLayoutComponentService', bizLayoutComponentService);

	bizLayoutComponent.$inject = ["bizLayoutComponentService", "$compile", "container"];
	bizLayoutComponentService.$inject = ["$http"]

	function bizLayoutComponent(bizLayoutComponentService, $compile, container) {
		var directive = {
			restrict: "A",
			link: bizLayoutComponentLink
		}

		function bizLayoutComponentLink(scope, element, attrs) {
			var htm = '<biz-container-show container="LayoutComponent.Container"></biz-container-show>';

			if (!attrs.bizLayoutComponent)
				return;

			bizLayoutComponentService.GetLayoutComponent(attrs.bizLayoutComponent).then(GetLayoutComponentCallback);

			function GetLayoutComponentCallback(response) {
				scope.LayoutComponent = BizPartCoreHelpers.getResponseValue(response, {});

				if (scope.LayoutComponent.Container) {
					scope.LayoutComponent.Container = new container(scope.LayoutComponent.Container);
					var compiled = $compile(htm)(scope);
					element.html(compiled);
				}
			}
		}

		return directive;
	}

	function bizLayoutComponentService($http) {
		var servicepath = siteRootPath + "api/layout/";

		this.GetLayoutComponent = function (type) {
			return $http.get(servicepath + "GetLayoutComponentForUser", {
				params: {
					type: type
				}
			});
		}
	}
})(window.angular);
